var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    className: "default"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M1 4h22a1 1 0 011 1v14a1 1 0 01-1 1H1a1 1 0 01-1-1V5a1 1 0 011-1zm0 1v14h22V5H1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 7h24v3H0z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    className: "alt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 4h22a1 1 0 011 1v2H0V5a1 1 0 011-1zm-1 6h24v9a1 1 0 01-1 1H1a1 1 0 01-1-1v-9z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M1 4h22a1 1 0 011 1v14a1 1 0 01-1 1H1a1 1 0 01-1-1V5a1 1 0 011-1zm0 1v14h22V5H1z"
  }))));
}
SvgCreditCard.displayName = 'CreditCard';
export default SvgCreditCard;